/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { DashboardAverageItem } from '@gh/builder-shared-data';
import { isNil } from 'lodash';

@Component({
  standalone: false,
  selector: 'gh-builder-average-widget',
  templateUrl: 'average-widget.component.html',
  styleUrls: ['average-widget.component.scss'],
})
export class AverageWidgetComponent {
  @Input() items: DashboardAverageItem[];

  isValueExists(value: any): boolean {
    return !isNil(value);
  }
}
